import find from 'lodash/find';

import type { AppData } from '../../types/app_data';
import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';
import { RelationToUser } from '../../types/driver';
import { isEligibleForGeicoQuotes } from '../../utils/onboard';

// Ask user for occupation
export const OccupationListStep: Step = {
  id: 'occupationList',
  pathname: '/occupationList',

  canShow: (appData: AppData) => {
    const state = appData?.address?.state || '';
    const userDriver = find(appData.drivers, (driver) => driver.relationToUser === RelationToUser.Insured);

    if (!userDriver) {
      return false;
    }

    if (appData.signupParams?.needNNOInsurance === true) {
      return false;
    }

    if (['DE', 'MA', 'WA', 'MI'].includes(state)) {
      return false;
    }

    /**
     * Show this step if user select 'Employed'
     */
    if (userDriver.occupation === 'Other' && userDriver.industry === 'Business/Sales/Office') {
      return isEligibleForGeicoQuotes(appData) || state === 'NC';
    }

    return false;
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    const userDriver = find(appData.drivers, (driver) => driver.relationToUser === RelationToUser.Insured);
    return !!userDriver?.occupation && !!userDriver?.industry;
  },
  category: () => StepCategory.Drivers,
};
